export default __webpack_public_path__ + "static/media/woman1.2322a789.png";